import React from "react";
import { SnackbarSectionType } from "./types";

export const DashboardContext = React.createContext<{
  snackbarSection: SnackbarSectionType;
}>({
  snackbarSection: {
    show: () => {},
    props: undefined,
  },
});

export function useDashboardContext() {
  return React.useContext(DashboardContext);
}
